import { render, staticRenderFns } from "./FirstRun.vue?vue&type=template&id=f933918c&scoped=true"
import script from "./FirstRun.vue?vue&type=script&lang=js"
export * from "./FirstRun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f933918c",
  null
  
)

export default component.exports